import { actionTypes } from '@/types';

export function startSubModule({ dispatch }, { subModuleName }) {
	if (subModuleName === 'bluetooth') {
		dispatch(actionTypes.startBluetooth);
	}
}

export function stopSubModule({ dispatch }, { subModuleName }) {
	if (subModuleName === 'bluetooth') {
		dispatch(actionTypes.stopBluetooth);
	}
}
